// delícious constants
export const GET_JOBS_URL = '/umbraco/api/job/jobsv2';
export const CLICK_EVENT = 'click';
export const CHANGE_EVENT = 'change';
export const INPUT_EVENT = 'input';
export const HIDE_CSS_CLASS = 'hide';
export const DISABLE_CSS_CLASS = 'disable';
export const DISPLAY_CSS_CLASS = 'display';
export const CLICKED_CSS_CLASS = 'clicked';
export const CATEGORY_FILTER_NAME = 'categories';
export const REGION_FILTER_NAME = 'regions';
export const REGION_ZIPCODE_FILTER_NAME = 'zipCode';
export const REGION_DISTANCE_FILTER_NAME = 'distance';
export const JOBTYPE_FILTER_NAME = 'types';
export const WORKPERIOD_FILTER_NAME = 'workPeriods';
export const FREE_TEXT_FILTER_NAME = 'query';
export const URL_PARAMS_SEPERATOR = ',';
